import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { IOfferCardProps, OfferCard } from 'shared/components/OfferCard';
import { MultiOfferBtn } from 'shared/components/OfferCard/components';
import { useTracking } from '../../utils/tracking/useTracking';
import { getObjectForAnalyticsAboutMultiOffers } from '../../utils/tracking/utils/getObjectForAnalyticsAboutMultiOffers';
import styles from './styles.css';

interface IMultiOfferContainerProps {
  multiOffers: IOfferCardProps[];
}

export const MultiOfferContainer: React.FC<IMultiOfferContainerProps> = ({ multiOffers }) => {
  const { trackShowMultiOffers, trackClickOpenMultiOffer } = useTracking();
  const [isOpen, setIsOpen] = useState(false);
  const deviceType = useDeviceType();
  const $refList = useRef<HTMLUListElement | null>(null);
  const firstOffer = multiOffers[0];
  const nestedOffers = multiOffers.slice(1);

  const showOffers = useCallback(() => {
    setIsOpen(true);
    trackClickOpenMultiOffer();
  }, [trackClickOpenMultiOffer]);

  const hideOffers = useCallback(() => {
    if ($refList.current) {
      $refList.current.scrollIntoView({
        behavior: 'smooth',
      });
    }
    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (isOpen) {
      const bank = firstOffer.title.name;
      const offers = getObjectForAnalyticsAboutMultiOffers(multiOffers);

      trackShowMultiOffers(bank, offers);
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, [isOpen]);

  return (
    <ul ref={$refList} className={styles['list']}>
      <li className={cn(styles['first-card'], styles[deviceType], isOpen && styles['active'])}>
        <div className={styles['first-card-wrapper']}>
          <OfferCard
            {...firstOffer}
            multiOfferBtn={
              isOpen ? null : <MultiOfferBtn isToggle={isOpen} text={'Все предложения'} handler={showOffers} />
            }
          />
        </div>
      </li>

      {isOpen ? (
        <li>
          <ul className={styles['list']}>
            {nestedOffers.map((el, index) => {
              return (
                <li key={index} className={cn(styles['nested-card'], styles[deviceType])}>
                  <OfferCard {...el} />
                </li>
              );
            })}
          </ul>
          <div className={cn(styles['btn-wrapper'], styles[deviceType])}>
            <MultiOfferBtn text={'Свернуть'} isToggle={isOpen} handler={hideOffers} />
          </div>
        </li>
      ) : null}
    </ul>
  );
};
